import { useEffect, useRef } from 'react';
import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = () => {

  const sidebarWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const initializeScroll = () => {
      if (sidebarWrapperRef.current) {
        setTimeout(()=> {
          const element = sidebarWrapperRef.current;
          if (element) {
              const vh = window.innerHeight; // Get the current height of the viewport
              const newHeight = `${vh - 93}px`; // Example dynamic calculation
            element.style.height = newHeight;
          }
        }, 10);
      }
    };

    initializeScroll();
    return () => {
    };
  }, []); 

  return (
    <div id="kt_app_sidebar_cover" 
      //ref={sidebarCoverRef}
      className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      <div
        id='kt_app_sidebar_menu_wrapper'
        ref={sidebarWrapperRef}
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'        
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3 pb-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
